import {
  CasesValue,
  TCaseExamples,
} from "../../../services/api/instances/casesApi/types";

type FieldMapping = {
  exampleKey: keyof TCaseExamples;
  setValue: (value: CasesValue, fieldValue: string) => void;
}[];

const FIELD_MAPPING: FieldMapping = [
  {
    exampleKey: "input",
    setValue: (value, fieldValue) => {
      value.case_object.case_artifacts_chain.input_artifact = fieldValue;
    },
  },
  {
    exampleKey: "output",
    setValue: (value, fieldValue) => {
      value.case_object.case_artifacts_chain.output_artifact = fieldValue;
    },
  },
  {
    exampleKey: "consumer",
    setValue: (value, fieldValue) => {
      value.case_object.case_artifacts_chain.consumer = fieldValue;
    },
  },
  {
    exampleKey: "summary",
    setValue: (value, fieldValue) => {
      value.case_object.case_info.task_description = fieldValue;
    },
  },
];

export const transferCaseExampleToCaseValue = (
  example: Partial<TCaseExamples>,
  value: CasesValue,
  fields?: Array<keyof TCaseExamples>,
): CasesValue => {
  const result = structuredClone(value);

  const mappingsToApply =
    fields && fields.length > 0
      ? FIELD_MAPPING.filter(({ exampleKey }) => fields.includes(exampleKey))
      : FIELD_MAPPING;
  for (const { exampleKey, setValue } of mappingsToApply) {
    const fieldValue = example[exampleKey];
    if (typeof fieldValue === "string") {
      setValue(result, fieldValue);
    }
  }

  return result;
};
